import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Home from "./pages/home/Home";
import Layout from "./components/Layout/Layout";
import About from "./pages/about/About";
import Faq from "./pages/FAQ/Faq";
import Contact from "./pages/contact/Contact";
import SellGiftCard from "./pages/sell_giftcards/SellGiftCard";
import GiftCardRates from "./pages/giftCard_rates/GiftCardRates";
import Blogs from "./pages/blogs/Blogs";
import BlogDetail from "./pages/blogDetail/BlogDetail";
import ProductFeatures from "./pages/product features/ProductFeature";
import PrivacyPolicy from "./pages/privacy policy/PrivacyPolicy";
import Statement from "./pages/accessibility statement/Statement";
import Terms from "./pages/Terms of use/Terms";
import AntiMoneyLaundering from "./pages/anti money laundering/AntiMoneyLaundering";
import Vip from "./pages/Vip/Vip";
import ErrorPage from "./pages/404_page/ErrorPage";
import LazyLoad from "react-lazyload";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<LazyLoad><Home /></LazyLoad>} />
          <Route path="/home" element={<LazyLoad><Home /></LazyLoad>} />
          <Route path="/contact-us" element={<LazyLoad><Contact /></LazyLoad>} />
          <Route path="/faqs" element={<LazyLoad><Faq /></LazyLoad>} />
          <Route path="/sellGiftCards" element={<LazyLoad><SellGiftCard /></LazyLoad>} />
          <Route path="/best-rates" element={<LazyLoad><GiftCardRates /></LazyLoad>} />
          <Route path="/blog" element={<LazyLoad><Blogs /></LazyLoad>} />
          <Route path="/blog/:url/:url" element={<LazyLoad><BlogDetail /></LazyLoad>} />
          <Route path="/Product-Features" element={<LazyLoad><ProductFeatures /></LazyLoad>} />
          <Route path="/privacy" element={<LazyLoad><PrivacyPolicy /></LazyLoad>} />
          <Route path="/statement" element={<LazyLoad><Statement /></LazyLoad>} />
          <Route path="/terms" element={<LazyLoad><Terms /></LazyLoad>} />
          <Route path="/AML-policy" element={<LazyLoad><AntiMoneyLaundering /></LazyLoad>} />
          <Route path="/Vip-Upgrades" element={<LazyLoad><Vip /></LazyLoad>} />
          <Route path="/about-us" element={<LazyLoad><About /></LazyLoad>} />
          <Route path="/money" element={<LazyLoad><AntiMoneyLaundering /></LazyLoad>} />
          <Route path="*" element={<LazyLoad><ErrorPage /></LazyLoad>} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
